import { render, staticRenderFns } from "./PropertyHolder.vue?vue&type=template&id=6602ef59&scoped=true&"
import script from "./PropertyHolder.vue?vue&type=script&lang=js&"
export * from "./PropertyHolder.vue?vue&type=script&lang=js&"
import style0 from "./PropertyHolder.vue?vue&type=style&index=0&id=6602ef59&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6602ef59",
  null
  
)

export default component.exports